class AddOnSlider extends HTMLElement {
  constructor() {
    super();
    this.swiperContainer = this.querySelector('swiper-container');
    this.nextButton = this.querySelector('.swiper-button-next');
    this.prevButton = this.querySelector('.swiper-button-prev');
    this.paginationElement = this.querySelector('.swiper-pagination');
    this.forms = this.querySelectorAll('.add-on-card__form');
    this.slidesPerView = parseFloat(this.dataset.slidesPerView) || 1.7;
  }

  connectedCallback() {
    this.initSwiper();
    this.bindForms();
  }

  initSwiper() {
    if (!this.swiperContainer) return;

    Object.assign(this.swiperContainer, {
      slidesPerView: 1.1,
      spaceBetween: 16,
      navigation: {
        nextEl: this.nextButton,
        prevEl: this.prevButton,
      },
      pagination: {
        el: this.paginationElement,
        type: 'progressbar',
      },
      
      breakpoints: {
        1500: {
          slidesPerView: this.slidesPerView,
          spaceBetween: 16,
        },
        1400: {
          slidesPerView: 1.3,
          spaceBetween: 16,
        },
        1200: {
          slidesPerView: 1.2,
          spaceBetween: 16,
        },
        1100: {
          slidesPerView: 1.1,
          spaceBetween: 16,
        },
        1000: {
          slidesPerView: 1.05,
          spaceBetween: 16,
        }
      },
    });
    this.swiperContainer.initialize();
    // ends the pre-init state in add-on-slider.css (Swiper Element keeps its own classes inside the shadow root)
    this.swiperContainer.classList.add('swiper-initialized');
    this.swiper = this.swiperContainer.swiper;
  }

  bindForms() {
    this.forms.forEach((form) => {
      form.addEventListener('submit', this.onSubmitHandler.bind(this));
    });
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const form = event.currentTarget;
    const submitButton = form.querySelector('[type="submit"]');

    if (submitButton.classList.contains('loading')) return;

    submitButton.setAttribute('aria-disabled', true);
    submitButton.classList.add('loading');

    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData(form);
    if (cart) {
      formData.append(
        'sections',
        cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
      cart.setActiveElement(document.activeElement);
    }
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          console.error(response.description);
          return;
        }

        if (!cart) {
          window.location = window.routes.cart_url;
          return;
        }

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'add-on-slider',
          productVariantId: formData.get('id'),
          cartData: response,
        });

        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        cart.renderContents(response);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('aria-disabled');
      });
  }
}

if (!customElements.get('add-on-slider')) {
  customElements.define('add-on-slider', AddOnSlider);
}
